import React from 'react';
import Config from '../../config/Config';
import { setCurrentProductId } from '../../redux/buyCourse/buyCourse.actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Zoom from '../utils/animations/zoom';
import Card from 'react-bootstrap/Card';
const ProductCard = ({
	product_tags,
	offer_price_usd,
	offer_price,
	original_price_usd,

	original_price,
	product_icon_url,
	product_tag_line,
	product_id,
	product_name_slug,
	setCurrentProductId,
	history,
	isInternational,
}) => {
	const originalPrice = isInternational ? original_price_usd : original_price;
	const offerPrice = isInternational ? offer_price_usd : offer_price;

	const getProductDetails = () => {
		localStorage.setItem('currentProductId', product_id);
		setCurrentProductId(product_id);
		history.push('/purchase');
	};

	let domainList = '';
	let domains = product_tags.split('|');
	domainList = Object.keys(domains).map((domain_key) => (
		<img
			src={Config.ASSETSPATH + 'img/' + domains[domain_key] + '_B.png'}
			alt=""
			key={domain_key}
		/>
	));

	let offer_price_display = '₹ ' + offerPrice;
	let original_price_display = '₹ ' + originalPrice;
	let offer_percent = '';
	if (offerPrice === originalPrice) {
		offer_percent = '';
		original_price_display = '';
	} else {
		offer_percent =
			Math.round(((originalPrice - offerPrice) / originalPrice) * 100) + '% off';
	}

	return (
		<Zoom>
			<Card style={{ width: '18rem', margin: '18px' }} className="mb-2">
				<Card.Header style={{ textAlign: 'center' }}>
					<img src={product_icon_url} className=" course-list-img" alt="courseimg" />
				</Card.Header>
				<Card.Body>
					<Card.Title>
						<div className="product-icons-list">
							<span className="course-short-desc">{domainList}</span>
							<span className="course-valid">{product_tag_line}</span>
						</div>
					</Card.Title>

					<div className="product-price">
						<div className="product-price-value">{offer_price_display}</div>
						<span className="product-price-offer">{original_price_display}</span>
						<span className="product-offer"> {offer_percent}</span>
						<div className="product-tax">Inclusive of Tax</div>
					</div>
					{isInternational ? (
						<a
							href={`${Config.WEBSITEURL}product/${product_name_slug}`}
							target="_blank"
							rel="noopener noreferrer"
							className="product-button-buy"
						>
							Learn More
						</a>
					) : (
						<div
							className="product-button-buy"
							onClick={() => getProductDetails()}
							style={{ cursor: 'pointer' }}
						>
							Learn More
						</div>
					)}
				</Card.Body>
			</Card>
		</Zoom>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		setCurrentProductId: (id) => dispatch(setCurrentProductId(id)),
	};
};

export default withRouter(connect(null, mapDispatchToProps)(ProductCard));
